import api from "./api.js";

export default class CommentApi {
  static async createComment(data) {
    return await api.post(`api/community-comment`, data);
  }

  static async getList(data) {
    return await api.get(`api/community-comment`, data);
  }

  static async getDetail(id, data) {
    return await api.get(`api/community-comment/${id}`, data);
  }

  static async deleteComment(commentId, params) {
    return await api.del(`api/community-comment/${commentId}`, params);
  }

  static async updateComment(commentId, data) {
    return await api.patch(`api/community-comment/${commentId}`, data);
  }
}
